export default {
  'financial.billsToReceive.form.situation': 'Situação',
  'financial.billsToReceive.form.situation.open': 'Abertos',
  'financial.billsToReceive.form.situation.liquidated': 'Liquidados',
  'financial.billsToReceive.form.filterByDate': 'Filtrar por Data de',
  'financial.billsToReceive.form.filterByDate.issue': 'Emissão',
  'financial.billsToReceive.form.filterByDate.maturity': 'Vencimento',
  'financial.billsToReceive.form.filterByDate.receipt': 'Recebimento',
  'financial.billsToReceive.form.reportType': 'Selecione o Tipo de Relatorio',
  'financial.billsToReceive.form.reportType.issue': 'Emissão',
  'financial.billsToReceive.form.reportType.maturity': 'Vencimento',
  'financial.billsToReceive.form.reportType.receipt': 'Recebimento',
  'financial.billsToReceive.form.reportType.chartOfAccounts': 'Plano de Contas',
  'financial.billsToReceive.form.synthetic': 'Sintético',
  'financial.billsToReceive.form.analitic': 'Analítico',
  'financial.billsToReceive.form.orderBy': 'Ordernar por',
  'financial.billsToReceive.form.orderBy.date': 'Data',
  'financial.billsToReceive.form.orderBy.description': 'Descrição',
  'financial.billsToReceive.form.orderBy.debtor': 'Devedor',
  'financial.billsToReceive.form.orderBy.code': 'Código',
  'financial.billsToReceive.form.orderBy.planAccount': 'Plano de Contas',
  'financial.billsToReceive.form.orderBy.documentType': 'Tipo de Documento',
  'financial.billsToReceive.form.moreOptions': 'Mais Opções',
  'financial.billsToReceive.form.moreOptions.documentsTypes':
    'Tipo de Documento',
  'financial.billsToReceive.form.moreOptions.insurers': 'Seguradora',
  'financial.billsToReceive.form.moreOptions.banks': 'Conta Bancária',
  'financial.billsToReceive.form.moreOptions.chartOfAccounts':
    'Plano de Contas',
  'financial.billsToReceive.form.moreOptions.selectCustomers':
    'Selecionar Clientes',
};
